import React from 'react';
import { motion } from 'framer-motion';
import { gallery3, gallery4, gallery5, gallery6 } from '../assets';

const SlidingImages = () => {
  const images = [
    gallery3,
    gallery4,
    gallery5,
    gallery6,
  ];

  const duplicatedImages = [...images, ...images, ...images];

  return (
    <div className="w-full md:overflow-hidden relative py-16">
      {/* Gradient overlays */}
      <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-cream to-transparent z-10 hidden md:block" />
      <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-cream to-transparent z-10 hidden md:block" />

      <motion.div
        className="flex gap-6"
        animate={{
          x: [0, -2400],
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 100,
            ease: "linear",
          },
        }}
        viewport={{ once: true }}
      >
        {duplicatedImages.map((image, index) => (
          <motion.div
            key={index}
            className="flex-shrink-0 w-72 h-96 rounded-xl overflow-hidden shadow-xl group cursor-pointer"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={image}
              alt={`Wedding moment ${index + 1}`}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default SlidingImages;
